var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12C5.25 11.5875 5.5875 11.25 6 11.25C6.4125 11.25 6.75 11.5875 6.75 12C6.75 12.4125 6.4125 12.75 6 12.75C5.5875 12.75 5.25 12.4125 5.25 12ZM9 11.25H12C12.4125 11.25 12.75 11.5875 12.75 12C12.75 12.4125 12.4125 12.75 12 12.75H9C8.5875 12.75 8.25 12.4125 8.25 12C8.25 11.5875 8.5875 11.25 9 11.25ZM13.5 15H4.5C4.08675 15 3.75 14.6632 3.75 14.25V9.75H14.25V14.25C14.25 14.6632 13.9132 15 13.5 15M4.5 4.5H5.25V5.25C5.25 5.6625 5.5875 6 6 6C6.4125 6 6.75 5.6625 6.75 5.25V4.5H11.25V5.25C11.25 5.6625 11.5875 6 12 6C12.4125 6 12.75 5.6625 12.75 5.25V4.5H13.5C13.9132 4.5 14.25 4.83675 14.25 5.25V8.25H3.75V5.25C3.75 4.83675 4.08675 4.5 4.5 4.5M13.5 3H12.75V2.25C12.75 1.8375 12.4125 1.5 12 1.5C11.5875 1.5 11.25 1.8375 11.25 2.25V3H6.75V2.25C6.75 1.8375 6.4125 1.5 6 1.5C5.5875 1.5 5.25 1.8375 5.25 2.25V3H4.5C3.2595 3 2.25 4.0095 2.25 5.25V14.25C2.25 15.4905 3.2595 16.5 4.5 16.5H13.5C14.7405 16.5 15.75 15.4905 15.75 14.25V5.25C15.75 4.0095 14.7405 3 13.5 3",
    fill: "black",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2048_3941",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12C5.25 11.5875 5.5875 11.25 6 11.25C6.4125 11.25 6.75 11.5875 6.75 12C6.75 12.4125 6.4125 12.75 6 12.75C5.5875 12.75 5.25 12.4125 5.25 12ZM9 11.25H12C12.4125 11.25 12.75 11.5875 12.75 12C12.75 12.4125 12.4125 12.75 12 12.75H9C8.5875 12.75 8.25 12.4125 8.25 12C8.25 11.5875 8.5875 11.25 9 11.25ZM13.5 15H4.5C4.08675 15 3.75 14.6632 3.75 14.25V9.75H14.25V14.25C14.25 14.6632 13.9132 15 13.5 15M4.5 4.5H5.25V5.25C5.25 5.6625 5.5875 6 6 6C6.4125 6 6.75 5.6625 6.75 5.25V4.5H11.25V5.25C11.25 5.6625 11.5875 6 12 6C12.4125 6 12.75 5.6625 12.75 5.25V4.5H13.5C13.9132 4.5 14.25 4.83675 14.25 5.25V8.25H3.75V5.25C3.75 4.83675 4.08675 4.5 4.5 4.5M13.5 3H12.75V2.25C12.75 1.8375 12.4125 1.5 12 1.5C11.5875 1.5 11.25 1.8375 11.25 2.25V3H6.75V2.25C6.75 1.8375 6.4125 1.5 6 1.5C5.5875 1.5 5.25 1.8375 5.25 2.25V3H4.5C3.2595 3 2.25 4.0095 2.25 5.25V14.25C2.25 15.4905 3.2595 16.5 4.5 16.5H13.5C14.7405 16.5 15.75 15.4905 15.75 14.25V5.25C15.75 4.0095 14.7405 3 13.5 3",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2048_3941)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "black",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender_icon.fd880834c0c5511c7089c88b8cd8ce2b.svg";
export { ForwardRef as ReactComponent };